import { ActionTree } from 'vuex';
import { WidgetState } from './types';
import { RootState } from '../types';
import { IProperty, IWidget } from '@resclick/data-access';
import { compass } from '@resclick/compass';
import { parse } from 'qs';

export const actions: ActionTree<WidgetState, RootState> = {
  fetchSettings({ commit }, id): any {
    return compass
      .do('widgets', 'findOne', {
        params: { widgetId: id },
        populate: [
          { path: 'logo' },
          {
            path: 'property',
          },
        ],
      })
      .then(
        (response) => {
          const payload: IWidget = response && response.data;
          document.title = `${(payload.property as IProperty).name} | Online Booking`;
          commit('widgetLoaded', payload);
        },
        (error) => {
          commit('widgetLoadingError');
        },
      );
  },
};
